import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const KIOSKPICKERMODALLAUNCHERBLOCK_LEGACY_FIELD_ORDER = [];

const {
  kioskPickerModalLauncherBlockDescriptor: _generatedKioskPickerModalLauncherBlockDescriptor,
  kioskPickerModalLauncherBlockBlocDefinition,
  kioskPickerModalLauncherBlockDashboardLayout,
  kioskPickerModalLauncherBlockConfig,
  kioskPickerModalLauncherBlockResolveConfig,
  kioskPickerModalLauncherBlockProperties,
} = doodBlockConfig(
  {
    name: "Modal launcher / Kiosk picker",
    componentType: 'KioskPickerModalLauncherBlockComponent',
    category: 'content',
    description: "Modal launcher / Kiosk picker.",
    keywords: [],
    allowedIn: [{ bloc: 'MainLayoutComponent', slot: 'global_features' }],
    sharedFields: {}
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [],
          },
        ],
      },
    ],
  })
);

export function kioskPickerModalLauncherBlockDescriptor(): IBlockDescriptor;
export function kioskPickerModalLauncherBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskPickerModalLauncherBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskPickerModalLauncherBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskPickerModalLauncherBlockDescriptor, kioskPickerModalLauncherBlockProperties, fieldOrder);
}

export {
  kioskPickerModalLauncherBlockBlocDefinition,
  kioskPickerModalLauncherBlockDashboardLayout,
  kioskPickerModalLauncherBlockProperties,
  kioskPickerModalLauncherBlockConfig,
  kioskPickerModalLauncherBlockResolveConfig,
};

export type KioskPickerModalLauncherBlockConfig = typeof kioskPickerModalLauncherBlockConfig;
